import { createAsyncThunk } from '@reduxjs/toolkit';
import { RootState } from '../RootState';
import { getPanelTransactionsApi } from './api';
import { initialPanelTransactions } from './panel_transactions.initial';
import {
    PanelTransactionsApiResult,
    PanelTransactionsQuery,
} from './panel_transactions.types';

/** Campos cuyo cambio invalida la página actual. */
const FILTER_KEYS: (keyof PanelTransactionsQuery)[] = [
    'scope',
    'customerEmail',
    'transactionId',
    'paymentStatus',
    'paymentMethod',
    'yearMonth',
    'pageSize',
];

/**
 * Carga una página del listado de transacciones (`commercial_panel/transactions`).
 *
 * Los campos no enviados se heredan del estado, así que un cambio de filtro se
 * expresa con solo ese campo. Si cambia un filtro y no se pide una página
 * explícita, se vuelve a la primera: la paginación del servidor no tiene sentido
 * sobre un conjunto distinto.
 */
export const getPanelTransactions = createAsyncThunk<
    PanelTransactionsApiResult,
    Partial<PanelTransactionsQuery> | void,
    { state: RootState }
>('panel_transactions/getPanelTransactions', async (payload, thunkAPI) => {
    const state = thunkAPI.getState();
    const token = state.User?.token ?? '';
    const current = state.panel_transactions ?? initialPanelTransactions;
    const args = (payload ?? {}) as Partial<PanelTransactionsQuery>;

    const filtersChanged = FILTER_KEYS.some(
        (key) => args[key] !== undefined && args[key] !== current[key],
    );

    const query: PanelTransactionsQuery = {
        scope: args.scope ?? current.scope,
        customerEmail: args.customerEmail ?? current.customerEmail,
        // `??` no sirve acá: `null` es el valor con el que se SALE de la búsqueda
        // directa, y el operador lo trataría como "no vino" heredando el número
        // anterior — el buscador no se podría limpiar nunca.
        transactionId:
            args.transactionId !== undefined ? args.transactionId : current.transactionId,
        paymentStatus: args.paymentStatus ?? current.paymentStatus,
        paymentMethod: args.paymentMethod ?? current.paymentMethod,
        yearMonth: args.yearMonth ?? current.yearMonth,
        pageSize: args.pageSize ?? current.pageSize,
        page: args.page ?? (filtersChanged ? 0 : current.page),
    };

    return getPanelTransactionsApi(token, query);
});
